import { put, call, takeLatest, select, take, actionChannel, takeEvery } from "redux-saga/effects";
import * as Api from "../api";
import * as ActionConstants from "../actions/actionConstants";
import {SHOW_TOAST_WITH_PROPS,SHOW_LOADER, HIDE_LOADER } from '../.././../common/actionConstants';
import { HIDE_DIALOGUE_BOX } from "../../../components/DialogueBox/actionConstants";
import * as WorkkardErrorConstant from '../errorConstant';
import { StringConstants,RightPanelConstant,ErrorCode } from '../constants';
import { logout } from './common';
import { getActivityDetail  } from './leftPanelContainer';
import {fetchCombinedViewData,updateCombinedViewData} from './combineView';
import * as PUBLIC_API_DIARY_ACTION from "../../../publicApiActions/diaryActions";
import * as PUBLIC_API_ACTIVITY_ACTION from "../../../publicApiActions/activityActions";
import  * as PUBLIC_API_PARTY  from "../../../publicApiActions/partyActions";
import { getAxiosError, GetNoteTemplateIdsByShortName, formatEpochDateTime } from '../.././../common/util';
import * as PUBLIC_API_NOTE_ACTIONS from "../../../publicApiActions/noteActions";
import { normalizePartiesList } from "../../../services/workkardDetail/MiddlePanelService";
import { normalizeNote } from "../../../common/normalizers/noteFields";
import { hydrateUsers } from "../../../common/sagas/userListSaga";
import { getOrgs } from "@/common/sagas/orgListSaga";
import { buildInlineActivityFieldPatch, DUE_DATE_TZ_FIELD_KEY } from "../inlineActivityFieldPatch";
import { fetchActivityById } from "../../CreationForms/AddEditActivity/store/activityFormApi";

export function* updatePanelDataPermissionSet({permission , payload}){
    try{
        switch(true){
          case (permission.isFetchNotes):
            return yield* fetchMiddlePanelNotesData({payload: payload});
          case (permission.isUpdateNotes):
            return yield* updateMiddlePanelNotesData({ payload: payload, isEdited: true });
          case (permission.noteEdited):
            return yield* updateMiddlePanelNotesData({ payload: payload, isEdited: true });

          case permission.isFetchFiles:
            return yield* fetchMiddlePanelFilesData({payload: payload});
          case permission.isUpdateFiles:
            return yield* updateMiddlePanelFilesData({payload:payload});
            
          case permission.isUpdateDiaries:
            return yield* fetchMiddlePanelDiariesData({payload: payload});

          case permission.isFetchLogs:
            return yield* fetchMiddlePanelLogsData({payload: payload});
          case permission.isUpdateLogs:
            return yield* updateMiddlePanelLogsData({payload:payload});

          case permission.isFetchParties:
            return yield* fetchMiddlePanelPartiesData({payload: payload});
          case permission.isUpdateParties:
            return yield* updateMiddlePanelPartiesData({payload:payload});

          case permission.isUpdateCombinedView:
            return yield* fetchCombinedViewData({payload:payload});
          default:
            return  null;
        }
    }
    catch(error){

    }
    finally{

    }
}


export function* fetchMiddlePanelData({payload}){
    try{
      yield put({ type: ActionConstants.SHOW_MIDDLE_PANEL_LOADER });
      yield put({
        type: ActionConstants.FETCH_MIDDLE_PANEL_DATA_SUCCESS,
        payload
      })
    }
    catch (error) {
  
    }
    finally {
      yield put({ type: ActionConstants.HIDE_MIDDLE_PANEL_LOADER });
    }
  }
  
  export function* fetchMiddlePanelFilterData({payload}){
    try{
      yield put ({
        type: ActionConstants.FETCH_MIDDLE_PANEL_FILTER_SUCCESS,
        payload
      })
    }
    catch (error) {
  
    }
    finally{
  
    }
  }
  
  export function* updateFileCaption({payload}){
    try{
      const {status} = yield call(Api.updateFileCaption,payload);
      if(status == 200){
        const getWorkkardDetailData=(state)=>state.workkardDetail;
        const workkardDetailData=yield select(getWorkkardDetailData);
        if (workkardDetailData.panelVisibility.toggleView==RightPanelConstant.NormalView){
          yield put ({
            type: ActionConstants.UPDATE_CAPTION_SUCCESS,
            payload
          })
        }
        else{
          yield put ({
            type: ActionConstants.UPDATE_COMBINED_VIEW_FILE_CAPTION,
            payload
          })
        }
  
      } 
      else if(status == ErrorCode.RedirectToLogout){
        yield* logout();
      }
      else{
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status:status, isErrorScreen:false  }
        });
      }      
    }
    catch (error) {
  
    }
  }
  
  export function* notesUpdateFileCaption({payload}){
    try{
      const {status} = yield call(Api.updateFileCaption,payload);
      if(status == 200){
        yield put ({
          type: ActionConstants.NOTES_UPDATE_FILE_CAPTION_SUCCESS,
          payload
        })
      }  else if(status == ErrorCode.RedirectToLogout){
        yield* logout();
      }
      else{
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status:status, isErrorScreen:false  }
        });
      }      
    }
    catch (error) {
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { isErrorScreen:false }
        });
    }
  }
  function* getNoteFilters(){
    try{
      let notefilters;
      const getnoteTemplateId = (state) => state.workkardDetail.activityDetail.activityTemplateType;
      const ActivityTemplateType = yield select(getnoteTemplateId);
      if(!_.isEmpty(ActivityTemplateType)){
        const getnoteFilters = (state) => state.workkardDetail.middlePanel.excludedFilters[ActivityTemplateType];
        const notes = yield select(getnoteFilters);
        const getNoteTemplates = (state) => state.workkardDetail.middlePanel.activityNoteTemplates[ActivityTemplateType];
        const notesTemplates = yield select(getNoteTemplates);
        notefilters = (GetNoteTemplateIdsByShortName(notesTemplates, notes) || []).toString()
      }
      return notefilters?.length > 0 ? notefilters : ""
    }
    catch(err)
    {
      console.log(err);
    }
  }

  function getNotesRequest(payload) {
    const request = payload && payload.request ? payload.request : (payload || {});
    return { ...request };
  }

  // The projection returns snake_case notes with epoch dates and numeric user
  // ids. Turn one page into the PascalCase view model the note components read.
  function* buildNotesPage(request, Data) {
    const userView = yield select((state) => state.sessionContextOidc.userView);
    const timezone = userView && userView.timezone;
    const rows = Array.isArray(Data.data) ? Data.data : [];

    rows.forEach((item) => {
      // Keep the epochs for comparing the two timestamps.
      const updatedEpoch = item.updated_date || 0;
      const reviewedEpoch = item.reviewed_date || 0;
      item.updated_date_epoch = updatedEpoch;
      item.reviewed_date_epoch = reviewedEpoch;
      item.pretty_created_date = formatEpochDateTime(item.created_date || 0, timezone);
      item.updated_date = formatEpochDateTime(updatedEpoch, timezone);
      item.reviewed_date_string = formatEpochDateTime(reviewedEpoch, timezone);
      item.published_date_string = item.internal_to_public
        ? formatEpochDateTime(updatedEpoch, timezone)
        : '';
    });

    const normalizedNotes = rows.map(normalizeNote);
    const noteUserIds = normalizedNotes.reduce((acc, n) => {
      if (n.CreatedBy) acc.push(n.CreatedBy);
      if (n.UpdatedBy) acc.push(n.UpdatedBy);
      if (n.ReviewerId) acc.push(n.ReviewerId);
      return acc;
    }, []);
    if (noteUserIds.length > 0) {
      yield* hydrateUsers(noteUserIds);
    }

    const noteOrgIds = normalizedNotes.reduce((acc, n) => {
      if (n.OrganizationId) acc.push(n.OrganizationId);
      return acc;
    }, []);
    if (noteOrgIds.length > 0) {
      yield* getOrgs(noteOrgIds);
    }

    return {
      total: Data.total ?? normalizedNotes.length,
      skip: Data.skip ?? request.skip ?? 0,
      take: Data.take ?? request.take ?? 10,
      data: normalizedNotes,
    };
  }

  export function* fetchMiddlePanelNotesData({payload}){
    const request = getNotesRequest(payload);
    const silent = !!request.silent;
    const suppressLoader = request.InternalToPublic || silent;
    try{
      delete request.InternalToPublic;
      delete request.silent;
      if(!suppressLoader) {
        yield put({ type: SHOW_LOADER });
      }
      var data, Data;
      if (request.type === 'activity' && request.noteFilters == undefined) {
        request.noteFilters = yield getNoteFilters();
      }
      Data = yield call(Api.getNotesData, request);
      if(Data.status == 200) {
        const notes = yield* buildNotesPage(request, Data);
        data = {
          notes: {
            ...notes,
            reviewFilter: request.reviewFilter ?? payload?.reviewFilter,
          },
          }
        if (request.type === 'activity' && payload?.excludedFilters)
        {
          data.excludedFilters=payload.excludedFilters
        }

        yield put ({
          type: ActionConstants.FETCH_MIDDLE_PANEL_NOTES_SUCCESS,
          payload: data
        })
      } else if(Data.status == ErrorCode.RedirectToLogout){
        yield* logout();
      } else if(silent){
        console.warn(`silent notes refresh failed with status ${Data.status}`);
      } else {
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status:Data.status, isErrorScreen:false  }
        });
        yield put ({
          type: ActionConstants.FETCH_MIDDLE_PANEL_NOTES_ERROR,
          payload: {errorMessage: WorkkardErrorConstant.FETCH_MIDDLE_PANEL_NOTES_ERROR[Data.status]}
        })
      }
  
    }
    catch (error) {
      if(silent){
        console.warn('silent notes refresh failed', error);
      } else {
        yield put ({
          type: ActionConstants.FETCH_MIDDLE_PANEL_NOTES_ERROR,
          payload: {errorMessage: error}
        })
      }
    }
    finally{
      if (!suppressLoader) {
        yield put({ type: HIDE_LOADER });
      }
      let data = payload?.updateFiltersAPI ? yield call(PUBLIC_API_NOTE_ACTIONS.updateActivityNoteFilters, payload.updateFiltersAPI):"";
    }
  }
  
export function* updateMiddlePanelNotesData({ payload, isEdited}){
    try{
        yield put({ type: ActionConstants.BUTTON_LOADER, payload: { publishNote: true}});

      var data, Data;
      const request = getNotesRequest(payload);
      if (request.type === 'activity' && !request.noteFilters) {
        request.noteFilters = yield getNoteFilters();
      }
      Data = yield call(Api.getNotesData, request);
      if(Data.status == 200) {
        const getItems = (state) => state.workkardDetail.middlePanel.notes;
        const items = yield select(getItems);
        const notes = yield* buildNotesPage(request, Data);
        data = {
          notes: {
            ...notes,
            reviewFilter: items.reviewFilter,
          }
        }
        if (isEdited && notes.data.length > 0){
          yield put({
            type: ActionConstants.REMOVE_EDITED_NOTE,
            payload: { nId: notes.data[0].Id }
          })
        }
        yield put ({
          type: ActionConstants.UPDATE_MIDDLE_PANEL_NOTES_SUCCESS,
          payload: data
        })        
      } else if(Data.status == ErrorCode.RedirectToLogout){
        yield* logout();
      } else {
        yield put ({
          type: ActionConstants.FETCH_MIDDLE_PANEL_NOTES_ERROR,
          payload: {errorMessage: WorkkardErrorConstant.FETCH_MIDDLE_PANEL_NOTES_ERROR[Data.status]}
        })
          yield put({
            type: ActionConstants.LOG_APPLICATON_ERROR,
            payload: { status : Data.status, isErrorScreen:false }
          });
      }
  
    }
    catch (error) {
      yield put ({
        type: ActionConstants.FETCH_MIDDLE_PANEL_NOTES_ERROR,
        payload: {errorMessage: error}
      })
    }
    finally{
      yield put({ type: ActionConstants.BUTTON_LOADER, payload: { publishNote: false}});
    }
  }
  
  export function* updateMiddlePnaelReviewNote({payload}){
    try{
      yield put({ type: ActionConstants.SHOW_MIDDLE_PANEL_LOADER });
      var data, Data;

      const request = getNotesRequest(payload);
      if (request.type === 'activity' && !request.noteFilters) {
        request.noteFilters = yield getNoteFilters();
      }
      Data = yield call(Api.getNotesData, request);
      if(Data.status == 200) {
        const getItems = (state) => state.workkardDetail.middlePanel.notes;
        const items = yield select(getItems);
        const notes = yield* buildNotesPage(request, Data);

        data = {
          notes: {
            ...notes,
            refreshNoteId: payload.noteId,
            filter : items.filter,
            type: items.type,
          }
        }
        yield put ({
          type: ActionConstants.UPDATE_MIDDLE_PANEL_REVIEW_SUCCESS,
          payload: data
        })
      } else if(Data.status == ErrorCode.RedirectToLogout){
        yield* logout();
      } else{
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status:Data.status, isErrorScreen:false  }
        });
        yield put ({
          type: ActionConstants.FETCH_MIDDLE_PANEL_NOTES_ERROR,
          payload: {errorMessage: WorkkardErrorConstant.FETCH_MIDDLE_PANEL_NOTES_ERROR[Data.status]}
        })
      }  
    }
    catch (error) {
      yield put ({
        type: ActionConstants.FETCH_MIDDLE_PANEL_NOTES_ERROR,
        payload: {errorMessage: error}
      })
    }
    finally{
      yield put({ type: ActionConstants.HIDE_MIDDLE_PANEL_LOADER });
    }
  }
  
  export function* fetchMiddlePanelFilesData({payload}){
    const silent = !!payload.silent;
    const getActivityListingTotal = (state) => state.workkardDetail.activityListing.total;
    const activityListingTotal = yield select(getActivityListingTotal);
    try{
      if(silent){
        // no loader
      }
      else if(activityListingTotal){
        yield put({ type: SHOW_LOADER });
      }
      else{
        yield put({ type: ActionConstants.SHOW_MIDDLE_PANEL_LOADER });
      }
      var data, Data;
      if (payload.type === 'All' && !payload.actId) {
        Data = yield call(Api.getWorkkardFilesData, ActionConstants.FETCH_MIDDLE_PANEL_WORKKARD_FILE_SUCCESS, payload);
      }
      else if (payload.type === 'activity' || payload.type === 'All'){
        Data = yield call(Api.getFilesData, ActionConstants.FETCH_MIDDLE_PANEL_FILE_SUCCESS, payload );
      } else if( payload.type === 'workkard'){
        Data = yield call(Api.getWorkkardFilesData, ActionConstants.FETCH_MIDDLE_PANEL_WORKKARD_FILE_SUCCESS, payload);
      }
      if(Data.status == 200){
        const fileGroups = Array.isArray(Data.Data) ? Data.Data : [];
        const fileUserIds = [];
        const fileOrgIds = [];
                
        fileGroups.forEach(group => {
            if (group.UserId) fileUserIds.push(group.UserId);
            if (group.OrgId) fileOrgIds.push(group.OrgId);
        });

        if (fileUserIds.length > 0) {
          yield* hydrateUsers(fileUserIds);
        }
        
        if (fileOrgIds.length > 0) {
          yield* getOrgs(fileOrgIds);
        }

        if (!payload.showWorkkardFiles) {
          const getItems = (state) => state.workkardDetail.middlePanel.files;
          const items = yield select(getItems);
          data = {
            files: {
              type: payload.type,
              total: Data.Total,
              skip: payload.skip || 0,
              take: payload.take || 10,
              filter: items.filter,
              largeView:payload.largeView,
              isSelectAll: silent ? !!items.isSelectAll : false,
              showToast:payload.showToast || false,
              ...Data
            }
          }
          yield put ({
            type: ActionConstants.FETCH_MIDDLE_PANEL_FILE_SUCCESS,
            payload: data
          });
        }

        if(payload.type === 'workkard' && payload.showWorkkardFiles){
          yield put({ type: ActionConstants.WORKKARD_DETAIL_MASTER_DATA_SUCCESS, payload:{workkardFiles:Data }});
        }

        const toastPayload={
          message:"Currently, you are viewing Activity & Workkard files.",
          type:"info",
          delayTime:5000,
          showActions: false,
          isCloseIcon:true,
          autoClose:false
        }

        if(payload.showToast && Data.Total){
          yield put({type:SHOW_TOAST_WITH_PROPS,payload:toastPayload})
        }
      } else if(Data.status == ErrorCode.RedirectToLogout){
        yield* logout();
      }else if(silent){
        console.warn(`silent files refresh failed with status ${Data.status}`);
      }else {
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status:Data.status, isErrorScreen:false  }
        });
        yield put ({
          type: ActionConstants.FETCH_MIDDLE_PANEL_FILE_ERROR,
          payload: {errorMessage: WorkkardErrorConstant.FETCH_MIDDLE_PANEL_FILE_ERROR[Data.status]}
        })
      }
  
    }
    catch (error) {
      if(silent){
        console.warn('silent files refresh failed', error);
      } else {
        yield put ({
          type: ActionConstants.FETCH_MIDDLE_PANEL_FILE_ERROR,
          payload: {errorMessage: error}
        })
      }
    }
    finally{
      if(silent){
        // no loader to hide
      }
      else if(activityListingTotal){
        yield put({ type: HIDE_LOADER });
      }
      else{
        yield put({ type: ActionConstants.HIDE_MIDDLE_PANEL_LOADER });
      }
    }
  }

  export function* updateMiddlePanelFilesData({payload}){
    try{
      yield put({ type: ActionConstants.SHOW_MIDDLE_PANEL_LOADER });
      var data, Data;
      if (payload.type === 'All' && !payload.actId) {
        Data = yield call(Api.getWorkkardFilesData, ActionConstants.FETCH_MIDDLE_PANEL_WORKKARD_FILE_SUCCESS, payload);
      }
      else if(payload.type === 'activity' || payload.type === 'All'){
        Data = yield call(Api.getFilesData, ActionConstants.FETCH_MIDDLE_PANEL_FILE_SUCCESS, payload );
      } else if( payload.type === 'workkard'){
        Data = yield call(Api.getWorkkardFilesData, ActionConstants.FETCH_MIDDLE_PANEL_WORKKARD_FILE_SUCCESS, payload);
      }
      if(Data.status == 200) {
        const getItems = (state) => state.workkardDetail.middlePanel.files;
        const items = yield select(getItems);
        data = {
          files: {
            type: payload.type,
            total: Data.Total,
            skip: payload.skip || 0,
            take: payload.take || 10,
            filter: items.filter,
            largeView:payload.largeView,
            isSelectAll:false,
            ...Data
          }
        }
        yield put ({
          type: ActionConstants.UPDATE_MIDDLE_PANEL_FILES_SUCCESS,
          payload: data
        })
      } else if(Data.status == ErrorCode.RedirectToLogout){
        yield* logout();
      } else {
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status:Data.status , isErrorScreen:false }
        });
        yield put ({
          type: ActionConstants.FETCH_MIDDLE_PANEL_FILE_ERROR,
          payload: {errorMessage: WorkkardErrorConstant.FETCH_MIDDLE_PANEL_FILE_ERROR[Data.status]}
        })
      }
  
    }
    catch (error) {
      yield put ({
        type: ActionConstants.FETCH_MIDDLE_PANEL_FILE_ERROR,
        payload: {errorMessage: error}
      })
    }
    finally{
      yield put({ type: ActionConstants.HIDE_MIDDLE_PANEL_LOADER });
    }
  }
  
  export function* fetchMiddlePanelDiariesData({payload}){
    const getActivityListingTotal = (state) => state.workkardDetail.activityListing.total;
    const activityListingTotal = yield select(getActivityListingTotal);
    try{
      if(activityListingTotal){
        yield put({ type: SHOW_LOADER });
      }
      else{
        yield put({ type: ActionConstants.SHOW_MIDDLE_PANEL_LOADER });
      }
      var Data,data;
      if(payload.type === 'activity') {
        Data = yield call(Api.getDiariesData, ActionConstants.FETCH_MIDDLE_PANEL_DIARIES_SUCCESS, payload );
      } else if(payload.type === 'workkard'){
        Data = yield call(Api.getWorkkardDiariesData, ActionConstants.FETCH_MIDDLE_PANEL_WORKKARD_DIARIES_SUCCESS, payload );
      }
      if(Data.status == 200){
        const getItems = (state) => state.workkardDetail.middlePanel.diaries;
        const items = yield select(getItems);
        const filterOptions = {
          filterOption: items.filter.filterOption,
          sort: items.filter.sort,
          todoOwners: payload.todoOwners
        };
        data = {
          diaries: {
            type: payload.type,
            skip: payload.skip || 0,
            take: payload.take || 10,
            total: Data.Total,
            todoOwners: items.todoOwners,
            data: Data.Data,
            filter: filterOptions,
            sortBy:payload.sortBy || items.sortBy
          }
        }
        if (items.type == payload.type && items.data.length > 0 && payload.skip == 0){
          yield* resetMiddlePanel({payload : {
            type: 'diaries',
            value: payload.type,
            filter: items.filter,
            todoOwners: items.todoOwners,
            total: items.total,
            sortBy:''
          }})
        }
        yield put ({
          type: ActionConstants.FETCH_MIDDLE_PANEL_DIARIES_SUCCESS,
          payload: data
        })
      }  else if(status == ErrorCode.RedirectToLogout){
        yield* logout();
      } else {
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status:Data.status, isErrorScreen:false }
        });
        yield put ({
          type: ActionConstants.FETCH_MIDDLE_PANEL_DIARIES_ERROR,
          payload: {errorMessage: WorkkardErrorConstant.FETCH_MIDDLE_PANEL_DIARIES_ERROR[Data.status]}
        })
      }
  
    }
    catch (error) {
      yield put ({
        type: ActionConstants.FETCH_MIDDLE_PANEL_DIARIES_ERROR,
        payload: {errorMessage: error}
      })
    }
    finally{
      if(activityListingTotal){
        yield put({ type: HIDE_LOADER });
      }
      else{
        yield put({ type: ActionConstants.HIDE_MIDDLE_PANEL_LOADER });
      }
    }
  }
  
  export function* fetchWorkkardTodoOwners(payload){
    const getActivityListingTotal = (state) => state.workkardDetail.activityListing.total;
    const activityListingTotal = yield select(getActivityListingTotal);
    try{
      if(activityListingTotal){
        yield put({ type: SHOW_LOADER });
      }
      else{
        yield put({ type: ActionConstants.SHOW_MIDDLE_PANEL_LOADER });
      }
      const params = {
        wkId: payload.payload.type === StringConstants.workkard ? payload.payload.cId : 0,
        actId: payload.payload.type === StringConstants.activity ? payload.payload.actId : 0,
        filter: payload.payload.filterOption
      }
      var Data = yield call(Api.getWorkkardTodoOwners, ActionConstants.WORKKARD_TODO_OWNERS_SUCCESS, params );
      let diaryOwners = JSON.parse("[" + payload.payload.todoOwners + "]")
      Data.data && Data.data.forEach((data) => {
        if (!diaryOwners.includes(data.OwnerId)){
          diaryOwners.push(data.OwnerId)
        }
      })
      payload.payload.todoOwners = diaryOwners.toString();
      var data = {
        diaries: {
          type: payload.payload.type,
          todoOwners: Data.data,
        }
      }
      yield put({ type: ActionConstants.WORKKARD_TODO_OWNERS_SUCCESS, payload: data });
      yield* fetchMiddlePanelDiariesData(payload);
    }
    catch (error) {
  
    }
    finally {
      if(activityListingTotal){
        yield put({ type: HIDE_LOADER });
      }
      else{
        yield put({ type: ActionConstants.HIDE_MIDDLE_PANEL_LOADER });
      }
    }
  }
  
  export function* fetchMiddlePanelLogsData({payload}){
    const getActivityListingTotal = (state) => state.workkardDetail.activityListing.total;
    const activityListingTotal = yield select(getActivityListingTotal);
    try{
      if(activityListingTotal){
        yield put({ type: SHOW_LOADER });
      }
      else{
        yield put({ type: ActionConstants.SHOW_MIDDLE_PANEL_LOADER });
      }
      let data, Data;
      const logType = payload.type;
      if(payload.type === 'activity'){
        delete payload.type
        Data = yield call(Api.getLogData, ActionConstants.FETCH_MIDDLE_PANEL_LOG_SUCCESS, payload );
      } else if(payload.type ==='workkard'){
        delete payload.type
        Data = yield call(Api.getWorkkardLogData, ActionConstants.FETCH_MIDDLE_PANEL_WORKKARD_LOG_SUCCESS, payload );
      }
      if(Data.status == 200){
        const logEntries = Data.Data[0].Data;
        const logUserIds = logEntries.reduce((acc, entry) => {
          if (entry?.KeyObject?.UserId) acc.push(entry.KeyObject.UserId);
          return acc;
        }, []);
        if (logUserIds.length > 0) {
          yield* hydrateUsers(logUserIds);
        }
        data = {
          log: {
            type: logType,
            skip: payload.skip || 0,
            take: payload.take || 10,
            total: Data.Total,
            data: logEntries,
          }
        }
        yield put ({
          type: ActionConstants.FETCH_MIDDLE_PANEL_LOG_SUCCESS,
          payload: data
        })
      }  else if(status == ErrorCode.RedirectToLogout){
        yield* logout();
      } else {
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status:Data.status, isErrorScreen:false  }
        });
        yield put ({
          type: ActionConstants.FETCH_MIDDLE_PANEL_LOG_ERROR,
          payload: {errorMessage: WorkkardErrorConstant.FETCH_MIDDLE_PANEL_LOG_ERROR[Data.status]}
        })
      }
    }
    catch (error) {
      yield put ({
        type: ActionConstants.FETCH_MIDDLE_PANEL_LOG_ERROR,
        payload: {errorMessage: error}
      })
    }
    finally{
      if(activityListingTotal){
        yield put({ type: HIDE_LOADER });
      }
      else{
        yield put({ type: ActionConstants.HIDE_MIDDLE_PANEL_LOADER });
      }
    }
  }

  export function* updateMiddlePanelLogsData({payload}){
    try{
      yield put({ type: ActionConstants.SHOW_MIDDLE_PANEL_LOADER});
        var data,Data;
        if(payload.type==='activity'){
          Data=yield call(Api.getLogData,ActionConstants.FETCH_MIDDLE_PANEL_LOG_SUCCESS,payload);
        }else if(payload.type==='workkard'){
          Data = yield call(Api.getWorkkardLogData, ActionConstants.FETCH_MIDDLE_PANEL_WORKKARD_LOG_SUCCESS, payload);
        }
        if(Data.status==200){
          const logEntries = Data.Data[0].Data;
          const logUserIds = logEntries.reduce((acc, entry) => {
            if (entry?.KeyObject?.UserId) acc.push(entry.KeyObject.UserId);
            return acc;
          }, []);
          if (logUserIds.length > 0) {
            yield* hydrateUsers(logUserIds);
          }
          data={
            logs:{
              total:Data.Total,
              skip:payload.skip || 0,
              take:payload.take || 10,
              data:logEntries
            }
          }
          yield put ({
            type: ActionConstants.UPDATE_MIDDLE_PANEL_LOG_SUCCESS,
            payload: data
          })
        }else if(status == ErrorCode.RedirectToLogout){
          yield* logout();
        } else {
          yield put({
            type: ActionConstants.LOG_APPLICATON_ERROR,
            payload: { status:Data.status, isErrorScreen:false  }
          });
          yield put ({
            type: ActionConstants.UPDATE_MIDDLE_PANEL_LOG_ERROR,
            payload: { errorMessage: WorkkardErrorConstant.FETCH_MIDDLE_PANEL_LOG_ERROR[Data.status]}
          })
        }
    }
    catch(error){
      yield put ({
        type: ActionConstants.UPDATE_MIDDLE_PANEL_LOG_ERROR,
        payload: {errorMessage: error}
      })
    }
    finally{
      yield put({ type: ActionConstants.HIDE_MIDDLE_PANEL_LOADER});
    }
  }
  
  export function* fetchMiddlePanelPartiesData({payload}){

    const getActivityListingTotal = (state) => state.workkardDetail.activityListing.total;
    const activityListingTotal = yield select(getActivityListingTotal);
    try{
     if(activityListingTotal){
        yield put({ type: SHOW_LOADER });
      }
      else{
        yield put({ type: ActionConstants.SHOW_MIDDLE_PANEL_LOADER });
      }
      let actionPayload;
      if(payload.type === 'activity' || payload.type === 'All'){
        actionPayload = {
          cId: payload.actId ? '' : payload.cId,
          actId: payload.actId || '',
          skip: payload.skip || 0,
          take: payload.take || 10,
          sortBy: payload.sortBy || 1,
          filterOption: JSON.stringify(payload.filterOption) || JSON.stringify(["Workkard", "Activity"]),
          sort: payload.sort || 'ALL',
          todoOwners: payload.todoOwners || '',
          rows: 25,
          page: 1,
          key: payload.key || ''
        }
      } else if( payload.type === 'workkard'){
        actionPayload = {
          cId: payload.cId || '',
          actId: '',
          skip: payload.skip || 0,
          take: payload.take || 10,
          sortBy: payload.sortBy || 1,
          filterOption: JSON.stringify(payload.filterOption) || JSON.stringify(["Workkard", "Activity"]),
          sort: 'OPEN',
          todoOwners: '',
          rows: 25,
          page: 1,
          key: payload.key || ''
        }
      }
      const Data = yield call(Api.getPartiesData, ActionConstants.FETCH_MIDDLE_PANEL_PARTIES_SUCCESS, actionPayload );
      const data = {
        parties : {
          type: payload.type,
          skip: payload.skip || 0,
          take: payload.take || 15,
          total: Data.Total,
          data: normalizePartiesList(Data),
          showToast:payload.showToast || false,
          filter: {
            filterOption: payload.filterOption || ["Workkard", "Activity"],
          }
        }
      }
      yield put ({
        type: ActionConstants.FETCH_MIDDLE_PANEL_PARTIES_SUCCESS,
        payload: data
      })
      const toastPayload={
        message:"Currently, you are viewing Activity & Workkard parties.",
        type:"info",
        delayTime:5000,
        showActions: false,
        isCloseIcon:true,
        autoClose:false
      }

      if(payload.showToast && Data.Total){
        yield put({type:SHOW_TOAST_WITH_PROPS,payload:toastPayload})
      }
    }
    catch (error) {
  
    }
    finally{
        if(activityListingTotal){
          yield put({ type: HIDE_LOADER });
        }
        else{
          yield put({ type: ActionConstants.HIDE_MIDDLE_PANEL_LOADER });
        }
      }
      
}

export function* updateMiddlePanelPartiesData({payload}){
  try{
    yield put({ type: ActionConstants.SHOW_MIDDLE_PANEL_LOADER });
    let actionPayload;
    if(payload.type === 'activity' || payload.type === 'All'){
      actionPayload = {
        cId: payload.actId ? '' : payload.cId,
        actId: payload.actId || '',
        skip: payload.skip || 0,
        take: payload.take || 10,
        sortBy: payload.sortBy || 1,
        filterOption: JSON.stringify(payload.filterOption) || JSON.stringify(["Workkard", "Activity"]),
        sort: payload.sort || 'ALL',
        rows: 25,
        page: 1,
        key: payload.key || ''
      }
    } else if( payload.type === 'workkard'){
      actionPayload = {
        cId: payload.cId || '',
        actId: '',
        skip: payload.skip || 0,
        take: payload.take || 10,
        sortBy: payload.sortBy || 1,
        filterOption: JSON.stringify(payload.filterOption) || JSON.stringify(["Workkard", "Activity"]),
        sort: 'OPEN',
        rows: 25,
        page: 1,
        key: payload.key || ''
      }
    }
    const Data = yield call(Api.getPartiesData, ActionConstants.FETCH_MIDDLE_PANEL_PARTIES_SUCCESS, actionPayload );
    const data = {
      parties : {
        type: payload.type,
        skip: payload.skip || 0,
        take: payload.take || 15,
        total: Data.Total,
        data: normalizePartiesList(Data),
      }
    }
    yield put ({
      type: ActionConstants.UPDATE_MIDDLE_PANEL_PARTIES_SUCCESS,
      payload: data
    })
  }
  catch (error) {

  }
  finally{
    yield put({ type: ActionConstants.HIDE_MIDDLE_PANEL_LOADER });
  }
}

export function* changeActivityResolution({ payload }) {
    try {
      //const response = yield call(Api.updateActivityInProgress, payload);
      const response =yield call(PUBLIC_API_ACTIVITY_ACTION.changeActivityResolution, payload.ActivityId,{progress_in_percent:payload.ddlActivityProgress});
      if(!response || response.status ==  ErrorCode.RedirectToLogout){
        if(response && response.status ==  ErrorCode.RedirectToLogout){
          yield* logout();
        } else {
            yield put({
            type: ActionConstants.LOG_APPLICATON_ERROR,
            payload: { status: response && response.status, isErrorScreen:false  }
            });
        }
      }else{
        yield put({
          type: ActionConstants.ACTIVITY_DETAIL_DATA_SUCCESS,
          payload: {
            activityId: payload.ActivityId,
            progress: response.progress_in_percent,
            resolution: response.resolution
          }
        });
        //TODO: implement skip take
        const getWorkkardDetailData = (state) => state.workkardDetail.workkardDetail;
        const getItems = (state) => state.workkardDetail.middlePanel;
        const items = yield select(getItems);
        
        if (items.notes.type == StringConstants.activity)
        {
          let notefilters = GetNoteTemplateIdsByShortName(items.activityNoteTemplates[payload.activityTemplateType], items.excludedFilters[payload.activityTemplateType]);
          const param = {
            type: StringConstants.activity,
            actId: payload.ActivityId,
            cId: '',
            skip: 0,
            take: items.notes.skip + items.notes.take || 10,
            sortBy: "0",
            reviewFilter: "0",
            noteFilters: notefilters?.length > 0 ? notefilters.toString() : ""

          }
          yield* updatePanelDataPermissionSet({ payload: param, permission:{isUpdateNotes:true} })
        }

        const workkardDetailData=yield select(getWorkkardDetailData);
        if (items.logs.type == StringConstants.activity) {
          const logsPayload = {
            type: StringConstants.activity,
            cId: workkardDetailData.Id,
            actId: payload.ActivityId,
            skip: 0,
            take: items.logs.skip + items.logs.take || 10
          }
          yield* updatePanelDataPermissionSet({ payload: logsPayload , permission:{isUpdateLogs:true}})
        }      
        if (payload.refreshActivityDetail){
          const payloadData = {
            payload: {
              actId: payload.ActivityId
            }
          }
          yield* getActivityDetail(payloadData);
        }
      }
    }
    catch (error) {
      console.log(getAxiosError(error).error);
    }
    finally {
    }
}


export function* writeNoteReview({ payload }) {
    try {

      yield put({ type: ActionConstants.SHOW_MIDDLE_PANEL_LOADER });
      yield put ({
        type: ActionConstants.UPDATE_REFRESH_NOTE_ID,
        payload: {id:payload.nId}
      })
      const response = yield call(Api.writeNoteReview, payload);

  
      if(response.status != 200){
        yield put({ type: ActionConstants.HIDE_MIDDLE_PANEL_LOADER });
        if(response.status ==  ErrorCode.RedirectToLogout){
          yield* logout();
        } else {
            yield put({
            type: ActionConstants.LOG_APPLICATON_ERROR,
            payload: { status: response.status, isErrorScreen:false  }
            });
        }    
        // yield put({type: HIDE_LOADER });
        // const errorMessage = response.ValidationMsg ? response.ValidationMsg : REASSIGN_ACTIVITY_ERROR_VALIDATION_MESSAGE[response.status];
        // yield put({type : SET_VALIDATION_ERROR_MESSAGE, payload : errorMessage })
        console.log(response);
      }else{

        const getnoteFilters = (state) => state.workkardDetail.middlePanel.excludedFilters;
        const notes = yield select(getnoteFilters);
        const getnoteTemplateId = (state) => state.workkardDetail.activityDetail;
        const activityDetail = yield select(getnoteTemplateId);
        const getNoteTemplates = (state) => state.workkardDetail.middlePanel.activityNoteTemplates;
        const notesTemplates = yield select(getNoteTemplates);
        let notefilters = GetNoteTemplateIdsByShortName(notesTemplates[activityDetail.activityTemplateType], notes[activityDetail.activityTemplateType]).toString()
            const param = {
          type: "activity",
          actId: payload.actId,
          cId: '',
          skip: 0,
          take: 10,
          sortBy: "0",
          reviewFilter: "0",
          noteId: payload.nId,
          noteFilters: notefilters?.length > 0 ? notefilters.toString() : ""
        }
        
        // yield* resetMiddlePanel({ payload: payloadtype });
        yield* updateMiddlePnaelReviewNote({ payload: param });
      }
    }
    catch (error) {
  
    }
    finally {
      //yield put({ type: HIDE_LOADER });
      yield put({ type: ActionConstants.HIDE_MIDDLE_PANEL_LOADER });
    }
  }
  
  export function* resetMiddlePanelInitialState() {
    try {
      yield put({ type: ActionConstants.SHOW_MIDDLE_PANEL_LOADER });
      yield put({ type: ActionConstants.RESET_MIDDLE_PANEL_INITIAL_STATE_SUCCESS });
      }
    catch (error) {
  
    }
    finally {
      yield put({ type: ActionConstants.HIDE_MIDDLE_PANEL_LOADER });
    }
  }
  
export function* resetMiddlePanel({ payload }) {
  try {
    yield put({ type: ActionConstants.SHOW_MIDDLE_PANEL_LOADER });
    yield put({ type: ActionConstants.RESET_MIDDLE_PANEL_INDIVIDUAL_TAB_SUCCESS, payload });
  }
  catch {

  }
  finally {
    yield put({ type: ActionConstants.HIDE_MIDDLE_PANEL_LOADER });
  }
} 
export function* updateExcludedFilters({ payload }) {
  try{

    yield put({ type: ActionConstants.UPDATE_ACTIVITY_EXCLUDED_FILTER ,payload});
  }
  catch(error)
  {
    console.debug(error);

  }
}

  export function* changeNoteType({ payload }) {
    try {
      const { status, Data } = yield call(Api.changeNoteType, ActionConstants.CHANGE_NOTE_TYPE, payload)
  
      if(status == 200){
        yield put({ type: ActionConstants.CHANGE_NOTE_TYPE_SUCCESS, payload: Data });
        yield put({ type: HIDE_DIALOGUE_BOX })
      } else if(status ==  ErrorCode.RedirectToLogout){
        yield* logout();
      } else {
          yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status: status, isErrorScreen:true  }
          });
      }    
    }
    catch {
  
    }
    finally {
      yield put({ type: HIDE_DIALOGUE_BOX })
    }
  }

  export function* changeDiarieTitle({ payload }) {
    try {
      const { status } = yield call(Api.changeDiarieTitle, ActionConstants.DIARIES_TITLE_EDIT_SUCCESS, payload)
  
      if(status == 200){
        yield put({ type: ActionConstants.DIARIES_TITLE_EDIT_SUCCESS, payload });
      } if(status ==  ErrorCode.RedirectToLogout){
        yield* logout();
      } else {
          yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status: status, isErrorScreen:false  }
          });
      }    
    }
    catch {
  
    }
    finally {
  
    }
  }
  
  export function* changeDiarieDueDate({ payload }) {
    try {
      const { Data, status, dueDateOn, dueDate } = yield call(Api.changeDiarieTitle, ActionConstants.DIARIES_DUE_DATE_EDIT_SUCCESS, payload);

      const updatePayload={
        cid:payload.cid,
        dueOn:dueDateOn,
        DueDate:dueDate
      }
      if(status == 200){
        yield put({ type: ActionConstants.DIARIES_DUE_DATE_EDIT_SUCCESS, payload:updatePayload});
      }if(status ==  ErrorCode.RedirectToLogout){
        yield* logout();
      } else {
          yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status: status, isErrorScreen:false  }
          });
      }    
    }
    catch {
  
    }
    finally {
  
    }
  }
  
  export function* changeDiarieActionComplete({ payload }) {
    try {

      const {status} = yield call(PUBLIC_API_DIARY_ACTION.actionsTodo, payload);
      //const { status } = yield call(Api.changeDiarieActionComplete, ActionConstants.DIARIES_ACTION_COMPLETE_SUCCESS, payload)
      if (status==200) {
        let Data, data;
        const getItems = (state) => state.workkardDetail;
        const items = yield select(getItems);
        let filterOption = Object.assign([], items.middlePanel.diaries.filter.filterOption);
        //filterOption.push(items.middlePanel.diaries.type)
        filterOption = [].concat(filterOption, ['activity', 'workkard'])
        const wkpayload = {
          cId: items.workkardDetail.Id,
          type: items.middlePanel.diaries.type,
          actId: items.activityDetail.activityId || 0,
          skip: 0,
          take: items.middlePanel.diaries.skip + items.middlePanel.diaries.take,
          sortBy: "SortByDueDate",
          filterOption: JSON.stringify(filterOption),
          sort: items.middlePanel.diaries.filter.sort,
          rows: items.middlePanel.diaries.skip + items.middlePanel.diaries.take,
          todoOwners: items.middlePanel.diaries.filter.todoOwners
        }        
        if (wkpayload.type === 'activity') {
          Data = yield call(Api.getDiariesData, ActionConstants.FETCH_MIDDLE_PANEL_DIARIES_SUCCESS, wkpayload);
        } else if (wkpayload.type === 'workkard') {
          Data = yield call(Api.getWorkkardDiariesData, ActionConstants.FETCH_MIDDLE_PANEL_WORKKARD_DIARIES_SUCCESS, wkpayload);
        }
        if (Data.status == 200){
          data = Data.Data.filter(item => item.TodoId == payload.id)
        }
        yield put({ type: ActionConstants.DIARIES_ACTION_COMPLETE_SUCCESS, payload, data });
      }
      if(status ==  ErrorCode.RedirectToLogout){
        yield* logout();
      } else {
          yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status: status, isErrorScreen:false  }
          });
      }    
    }
    catch(error) {
      console.log(getAxiosError(error).error);
    }
    finally {
  
    }
  }
  
  // Todo : need to remove
  export function* changeDiarieActionCancelled({ payload }) {
    try {
      
      const status  = yield call(PUBLIC_API_DIARY_ACTION.cancelTodo, payload);

      //yield call(Api.changeDiarieActionCancelled, ActionConstants.DIARIES_ACTION_CANCELLED_SUCCESS, payload)
        yield put({ type: ActionConstants.DIARIES_ACTION_CANCELLED_SUCCESS, payload });
    }
    catch(error) {
      console.log(getAxiosError(error).error);
    }
    finally {
  
    }
  }

  export function* fetchWorkardLetters({payload}){
    try{
      const data = yield call(Api.fetchWorkardLetters,ActionConstants.FETCH_WORKKARD_LETTER_REQUEST, payload)
      if(data.status == 200){
        const DATA = {
            skip: payload.skip || 0,
            take: payload.take || 20,
            sortBy : payload.sortBy || 1,
            rows:payload.rows || 20,
            filterOption: payload.filterOption || ['all'],
            data: {
              Total : data.result.length,
              Data :data.result
            },
        }
        yield put({ type : ActionConstants.FETCH_WORKKARD_LETTER_REQUEST_SUCCESS, payload : DATA})
      }
  
    }
    catch{
  
    }
    finally{
  
    }
  }

  export function* resetWorkkardFilesInitialState() {
    try {
      yield put({ type: SHOW_LOADER });
      yield put({ type: ActionConstants.RESET_WORKKARD_FILES_REQUEST_SUCCESS });
      }
    catch (error) {
  
    }
    finally {
      yield put({ type: HIDE_LOADER });
    }
  }

  export function* resetWorkkardLettersInitialState() {
    try {
      yield put({ type: SHOW_LOADER });
      yield put({ type: ActionConstants.RESET_WORKKARD_LETTERS_REQUEST_SUCCESS });
      }
    catch (error) {
  
    }
    finally {
      yield put({ type: HIDE_LOADER });
    }
  }

  export function* saveAndUpdateFileCaption({payload}){
    try{
      const data = yield call(Api.saveAndUpdateFileCaption,ActionConstants.SAVE_AND_UPDATE_FILE_CAPTION, payload)
    }
    catch{
  
    }
    finally{
  
    }
  }

export function* deleteAssociatedParty({ payload }) {
  try {
    const response = yield call(PUBLIC_API_PARTY.deAssociateParty, payload)
    if (response.status == 200) {
      yield put({ type: ActionConstants.DELETE_ASSOCIATED_PARTY_REQUEST_SUCCESS, payload: payload })
    }
    if(response.status ==  ErrorCode.RedirectToLogout){
      yield* logout();
    }
    else if(response.status==ErrorCode.Fail && response.toastPayload)
    {
       yield put({type:SHOW_TOAST_WITH_PROPS,payload:response.toastPayload});
    }
     else {
        yield put({
        type: ActionConstants.LOG_APPLICATON_ERROR,
        payload: { status: response.status, isErrorScreen:false  }
        });
    }    
  }
  catch (error) {
    console.log(getAxiosError(error).error);
  }
  finally {
  }
}

export function* fetchReOpenReasonList({ payload }) {
  try {
    yield put({ type: SHOW_LOADER });
    const response = yield call(Api.fetchReOpenReasonList, payload.templateId)
    yield put({ type: HIDE_LOADER });
    if (response.status == 200) {
      if(response.wrrList && response.wrrList.length){
        yield put({ type: ActionConstants.SET_REOPEN_REASON_LIST, payload: {reasons: response.wrrList , subReasons: response.wkdReopensubReasonList} })
      }
    }if(response.status ==  ErrorCode.RedirectToLogout){
      yield* logout();
    } else {
        yield put({
        type: ActionConstants.LOG_APPLICATON_ERROR,
        payload: { status: response.status, isErrorScreen:false  }
        });
    }    
  }
  catch (error) {
    console.log(error);
    
  }
  finally {
    yield put({ type: HIDE_LOADER });
  }
}
export function* updateActivityField({ payload }) {
  try {
    yield put({ type: ActionConstants.SHOW_DETAIL_PAGE_LOADER });
    const { callback, hdnActId, ...editedFields } = payload;

    const getActivityDetailState = (state) => state.workkardDetail.activityDetail;
    const activityDetail = yield select(getActivityDetailState);
    const activityId = hdnActId || activityDetail?.activityId;

    const activityByIdResponse = yield call(fetchActivityById, { activityId });
    const templateShortName = (activityByIdResponse?.Data ?? activityByIdResponse)?.template_name;

    const fieldsResponse = yield call(Api.fetchActivityTemplateFields, templateShortName);
    const fieldsMeta = fieldsResponse?.fields ?? fieldsResponse?.data ?? fieldsResponse?.Data ?? [];

    if (editedFields[DUE_DATE_TZ_FIELD_KEY]) {
      const getTzData = (state) => state.sessionContextOidc?.tzData || [];
      const tzData = yield select(getTzData);
      const matchedTz = tzData.find((tz) => tz.standard_time_zone === editedFields[DUE_DATE_TZ_FIELD_KEY]);
      if (matchedTz?.mapped_time_zone) {
        editedFields[DUE_DATE_TZ_FIELD_KEY] = matchedTz.mapped_time_zone;
      }
    }

    const apiPayload = buildInlineActivityFieldPatch(editedFields, Array.isArray(fieldsMeta) ? fieldsMeta : []);
    const response = yield call(Api.updateActivityTemplateFields, activityId, apiPayload);
    const isError = !response || response.status === 400 || response.error;

    if (!isError) {
      const getItems = (state) => state.workkardDetail;
      const items = yield select(getItems);
      if (items.middlePanel.activeTab == 3 && (items.middlePanel.logs.type == "activity")) {
        const paramLogs = {
          type: items.middlePanel.logs.type,
          cId: items.workkardDetail.Id,
          actId: items.activityDetail.activityId,
          skip: 0,
          take: 10,
          sortBy: "0"
        };
        yield* updatePanelDataPermissionSet({ payload: paramLogs, permission: { isUpdateLogs: true } });
      }
      const { activityDetail: refreshedActivityDetail, status } = yield call(Api.getActivityDetail, activityId);
      if (status == 200 && refreshedActivityDetail) {
        yield put({ type: ActionConstants.ACTIVITY_DETAIL_DATA_SUCCESS, payload: refreshedActivityDetail });
      }
      if (callback) callback();
    } else if (response?.status == ErrorCode.RedirectToLogout) {
      yield* logout();
    } else {
      yield put({
        type: ActionConstants.LOG_APPLICATON_ERROR,
        payload: { status: response?.status, isErrorScreen: false }
      });
    }
  }
  catch (error) {
    console.log('error: ', error);
  }
  finally {
    yield put({ type: ActionConstants.HIDE_DETAIL_PAGE_LOADER });
  }
}

// export function* getCloseActivityPermission({ payload }) {
//   try {
//     const { callback } = payload;
//     delete payload.callback;
//     const response = yield call(Api.getCloseAtivityPermission, ActionConstants.GET_CLOSE_ACT_PERMISSION, payload)
//     if (response) {
//      callback(response)
//     }
//   }
//   catch (error) {
//     console.log(error);
//   }

//   finally {
//   }
// }

export function* resetPostApiActionError() {
    yield put({ type: ActionConstants.RESET_POST_API_ACTION_ERROR_SUCCESS });
}

export default [
    takeLatest(ActionConstants.FETCH_MIDDLE_PANEL_DATA_REQUEST, fetchMiddlePanelData),
    takeLatest(ActionConstants.FETCH_MIDDLE_PANEL_FILTER_REQUEST, fetchMiddlePanelFilterData),

    takeLatest(ActionConstants.UPDATE_CAPTION, updateFileCaption),
    takeLatest(ActionConstants.NOTES_UPDATE_FILE_CAPTION,notesUpdateFileCaption),

    takeLatest(ActionConstants.FETCH_MIDDLE_PANEL_NOTES_REQUEST, fetchMiddlePanelNotesData),
    takeLatest(ActionConstants.UPDATE_MIDDLE_PANEL_NOTES_REQUEST, updateMiddlePanelNotesData),

    takeLatest(ActionConstants.FETCH_MIDDLE_PANEL_FILE_REQUEST, fetchMiddlePanelFilesData),
    takeLatest(ActionConstants.UPDATE_MIDDLE_PANEL_FILES_SUCCESS, updateMiddlePanelFilesData),

    takeLatest(ActionConstants.FETCH_MIDDLE_PANEL_DIARIES_REQUEST, fetchMiddlePanelDiariesData),
    takeLatest(ActionConstants.WORKKARD_TODO_OWNERS_REQUEST, fetchWorkkardTodoOwners),

    takeLatest(ActionConstants.FETCH_MIDDLE_PANEL_LOG_REQUEST, fetchMiddlePanelLogsData),
    takeLatest(ActionConstants.UPDATE_MIDDLE_PANEL_LOG_REQUEST,updateMiddlePanelLogsData),

    takeLatest(ActionConstants.FETCH_MIDDLE_PANEL_PARTIES_REQUEST, fetchMiddlePanelPartiesData),
    takeLatest(ActionConstants.CHANGE_ACTIVITY_RESOLUTION_REQUEST, changeActivityResolution),
    takeLatest(ActionConstants.WRITE_NOTE_REVIEW_REQUEST, writeNoteReview),
  takeLatest(ActionConstants.RESET_MIDDLE_PANEL_INITIAL_STATE_REQUEST, resetMiddlePanelInitialState),
  takeLatest(ActionConstants.RESET_MIDDLE_PANEL_INDIVIDUAL_TAB, resetMiddlePanel),
  takeLatest(ActionConstants.UPDATE_ACTIVITY_EXCLUDED_FILTER, updateExcludedFilters),
    takeLatest(ActionConstants.CHANGE_NOTE_TYPE, changeNoteType),
    takeLatest(ActionConstants.DIARIES_TITLE_EDIT_REQUEST, changeDiarieTitle),
    takeLatest(ActionConstants.DIARIES_DUE_DATE_EDIT_REQUEST, changeDiarieDueDate),
    takeLatest(ActionConstants.DIARIES_ACTION_COMPLETE_REQUEST, changeDiarieActionComplete),
    takeLatest(ActionConstants.DIARIES_ACTION_CANCELLED_REQUEST, changeDiarieActionCancelled),
    takeLatest(ActionConstants.FETCH_WORKKARD_LETTER_REQUEST, fetchWorkardLetters),
    takeLatest(ActionConstants.SAVE_AND_UPDATE_FILE_CAPTION, saveAndUpdateFileCaption),
    takeLatest(ActionConstants.DELETE_ASSOCIATED_PARTY_REQUEST, deleteAssociatedParty),
    takeLatest(ActionConstants.RESET_WORKKARD_FILES_REQUEST,resetWorkkardFilesInitialState),
    takeLatest(ActionConstants.RESET_WORKKARD_LETTERS_REQUEST,resetWorkkardLettersInitialState),
    takeLatest(ActionConstants.FETCH_REOPEN_REASON_LIST, fetchReOpenReasonList),
    takeLatest(ActionConstants.UPDATE_ACTIVITY_FIELD, updateActivityField),
    takeLatest(ActionConstants.RESET_POST_API_ACTION_ERROR_REQUEST, resetPostApiActionError)
  ];
  